const QUERIES = {
  USERS_LIST: 'users-list',
  ADVERTISEMENT_LIST: 'advertisement-list',
  TIPSTER_LIST: 'tipster-list',
  TYPES_LIST: 'tipster-type-list',
  COUNTRY_LIST: 'country-list',
  SPORT_LIST: 'sport-list',
  COMPETITION_LIST: 'competition-list',
  PARTICIPANTS_LIST: 'participants-list',
  BOOKIE_LIST: 'bookie-list',
  BET_LIST: 'bet-list',
  SERVICES_LIST: 'service-list',
  EVENT_LIST: 'event-list',
  PICK_LIST: 'pick-list',
}

const MARKET_QUOTES = [
  { label: "totals", value: 1 },
  { label: "teamTotal", value: 2 },
  { label: "moneyline", value: 3 },
  { label: "spreads", value: 4 }
]

const URL_FIXED_PARAMS = [
  'limit',
  'page',
  'search',
  'fresh',
  'order',
  'sort',
  'include',
]

const noPayload = [
  'id',
  'result',
  '_persist',
  'algolia_id',
  'expired',
  'countries_sports',
  'countries_sports_id',
  'flag',
  'following',
  'services',
  'country',
  'username',
  'competitions',
  'competition',
  'participants',
  'picks',
  'password',
  'auth_provider',
  'photo',
  'logo',
  'countries',
  'sports',
  'sport',
  'logo_id',
  'flag_id',
  'roles',
  'services_sports',
  'tipster_types',
  'email_verified_at',
  'markets_sports',
  'last_login',
  'photo_id',
  'icon_id',
  'icon',
  'verify_hash',
  'balance',
  'base',
  'created_at',
  'updated_at',
  'deleted_at',
  'coins',
  'followers',
  'legacy',
  'metrics',
  'metrics_id',
  'channel_id',
  'plans',
  'room',
  'suscriptions',
  'users_tipster_types',
  'users_tipsters_types_id',
  'metadata',
  'active',
  'amount',
  'percentage',
  'tipster',
  'users',
  'image_id',
  'image',
  'base_id',
  'newEmail',
  'newPassword',
  'wallet_id',
  'device_tokens',
  'pending_messages',
  'tipster_banner_id',
    'channel',
    'service',
    'stripe_customer_id',
    // Relaciones/escalares gestionados por el backend (no permitidos en los DTO de home management)
    'article',
    'category',
    'categories',
    'cover_image',
    'cover_image_id',
]

export { QUERIES, MARKET_QUOTES, URL_FIXED_PARAMS, noPayload }
